import React from 'react'; 
import { IBasicTextArea } from '../../../interfaces/buttons/buttons';



const BasicTextArea = ({value, setValue, className, isDisabled = false, placeholder, maxLength}: IBasicTextArea) => {
    return (
        <div className="tc-textarea-wrapper">
            <textarea 
                className={`tc-textarea${className ?? ''}`}
                placeholder={placeholder ?? ''}
                value={value}
                onChange={e => setValue(e.target.value)}
                disabled={isDisabled}
                maxLength={maxLength}
            />
            {!!maxLength &&
                <span className='tc-length-counter'>{value.length} / {maxLength}</span>
            }
        </div>
    )
}

export default BasicTextArea